import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins, Emit } from "vue-property-decorator";
// QUINLAN
import BaseMixer from "../../BaseMixer";
import { IPageElementDTO } from "@/store/models/pageManager/PageManager";
let PageElementUpsertComponent = /** @class */ (() => {
    var _a;
    let PageElementUpsertComponent = class PageElementUpsertComponent extends Mixins(BaseMixer) {
        checkAndSendSave() {
            this.validate("pageElementObserver").then((res) => {
                if (res) {
                    return this.save();
                }
            });
        }
        save() { }
        cancel() { }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof IPageElementDTO !== "undefined" && IPageElementDTO) === "function" ? _a : Object)
    ], PageElementUpsertComponent.prototype, "model", void 0);
    __decorate([
        Emit(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PageElementUpsertComponent.prototype, "save", null);
    __decorate([
        Emit(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PageElementUpsertComponent.prototype, "cancel", null);
    PageElementUpsertComponent = __decorate([
        Component
    ], PageElementUpsertComponent);
    return PageElementUpsertComponent;
})();
export default PageElementUpsertComponent;
